"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SingleSelect_1 = __importDefault(require("@components/SingleSelect"));
var react_1 = __importDefault(require("react"));
var treeDataUtil_1 = require("@features/ItemCommon/components/common/SelectTree/treeDataUtil");
function sortItems(categories) {
    return (0, treeDataUtil_1.sortCategories)(categories).map(function (cat) {
        var sortedCat = __assign({}, cat);
        if ('subCategories' in sortedCat && sortedCat.subCategories) {
            sortedCat.subCategories = (0, treeDataUtil_1.sortCategories)(sortedCat.subCategories);
        }
        return sortedCat;
    });
}
function flattenCategories(categories) {
    var disableParents = categories.map(function (cat) {
        if ('subCategories' in cat && cat.subCategories) {
            return __assign(__assign({}, cat), { isDisabled: true });
        }
        return cat;
    });
    return disableParents.flatMap(function (cat) {
        return 'subCategories' in cat && cat.subCategories ? __spreadArray([cat], __read(cat.subCategories), false) : cat;
    });
}
function SelectItem(_a) {
    var items = _a.items, setValue = _a.setValue, selectMode = _a.selectMode;
    var sortedCategories = sortItems(items);
    // To simulate group of categories, we simply disable the parent category
    var categoriesToRender = selectMode === treeDataUtil_1.TreeOpenMode.ONE_LEVEL_DROPDOWN ? sortedCategories : flattenCategories(sortedCategories);
    return (react_1.default.createElement(SingleSelect_1.default, { options: categoriesToRender || [], getOptionLabel: function (valueItem) { return valueItem.name; }, getOptionValue: function (valueItem) { return String(valueItem.id); }, onChange: function (valueItem) {
            valueItem && setValue(valueItem);
        }, className: "category-dropdown", isSearchable: true, defaultMenuIsOpen: true, isMenuPositionStatic: true, autoFocus: true, withSearchInputIcon: true, withTooltipAndTruncatedText: true, customCssProperties: {
            customBackgroundColorOnHover: '#F3F3F3',
        } }));
}
exports.default = SelectItem;
